// extracted by mini-css-extract-plugin
module.exports = {"PhotoTitleEditForm__submitBtn":"jo_a bhv_rm","PhotoTitleEditForm__cancelBtn":"jo_b bhv_rq bhv_rp"};